<template>
  <UIPreloader
    :message
    class="fixed inset-0 bg-white/75 dark:bg-gray-900/75 z-30"
  />
</template>

<script setup lang="ts">
import { UIPreloader } from '@ui/core'

type Props = {
  message?: string
}

defineProps<Props>()
</script>
